var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.375H21.5625V15.8125H11.5V14.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.25H21.5625V18.6875H11.5V17.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20.125H16.5312V21.5625H11.5V20.125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 18.6875H2.875V4.3125H8.02844L10.4866 6.76344L10.9034 7.1875H20.125V12.9375H21.5625V7.1875C21.5625 6.80625 21.411 6.44062 21.1415 6.17103C20.8719 5.90145 20.5062 5.75 20.125 5.75H11.5L9.04906 3.29906C8.91533 3.16454 8.7563 3.05781 8.58113 2.98502C8.40596 2.91224 8.21812 2.87485 8.02844 2.875H2.875C2.49375 2.875 2.12812 3.02645 1.85853 3.29603C1.58895 3.56562 1.4375 3.93125 1.4375 4.3125V18.6875C1.4375 19.0687 1.58895 19.4344 1.85853 19.704C2.12812 19.9735 2.49375 20.125 2.875 20.125H10.0625V18.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicationIcon);
export default __webpack_public_path__ + "static/media/indication-icon.a9cd6a1c.svg";
export { ForwardRef as ReactComponent };